module.exports = __webpack_public_path__ + "static/media/gogrello.ca5a9c41.png";